import React from "react";

// components
import { Header } from "../components/Header";

export const NotFound = () => {
  return (
    <>
      <Header title="404" />
      <div className="text-center mt-100">
        <div style={{ fontSize: "100px" }}>:(:</div>
        <div style={{ fontSize: "20px" }}>گم گشته است،</div>
        <div style={{ fontSize: "25px" }}>اینجا نیست!</div>
      </div>
    </>
  );
};
